import { useState, useEffect } from 'react';
import './App.css';
import './App-dark.css';
import OctoOcto from './OCTOOCTO.png';

function App() {
  const [text, setText] = useState('');
  const [wordCount, setWordCount] = useState(0);
  const [charCount, setCharCount] = useState(0);

  useEffect(() => {
    const darkModeMediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
    const handleDarkModeChange = (e) => {
      document.body.classList.toggle("dark", e.matches);
    };
    darkModeMediaQuery.addEventListener("change", handleDarkModeChange);

    handleDarkModeChange(darkModeMediaQuery);

    return () => {
      darkModeMediaQuery.removeEventListener("change", handleDarkModeChange);
    };
  }, []);

  useEffect(() => {
    // Update the word count
    if (text === "") {
      setWordCount(0);
    } else {
      const words = text.trim().split(/\s+/);
      const isEmptyArray = words.every(word => word === "");
      setWordCount(isEmptyArray ? 0 : words.length);
    }

    // Update the character count
    setCharCount(text.length);
  }, [text]);

  function handleKeyPress(event) {
    if (event.key === "Enter" && event.shiftKey) {
      event.preventDefault();
    }
  };

  return (
    <div className="App">
      <header>
        <br />
        <br />
        <h1>Text Counter</h1>
        <br />
      </header>
      <main>
        <div>
          <textarea
            className="text-area"
            onChange={(e) => setText(e.target.value.toLowerCase())}
            onKeyDown={handleKeyPress}
            onFocus={(e) => {
              setTimeout(() => {
                requestAnimationFrame(() => {
                  e.target.select();
                });
              }, 0);
              e.target.placeholder = '';
            }}
            onBlur={(e) => {
              if (e.target.value === '') {
                e.target.placeholder = 'paste your text...';
              }
            }}
            placeholder='paste your text...'
            rows={1}
            maxLength={25000}
          />
          <br />
          <br />
          <h4>
            <span className="char-counter">Chars: {charCount}</span>
            <span className="word-counter">Words: {wordCount}</span>
          </h4>
        </div>

        <div className="octo-octo-logo">
          <a href="https://octoocto.net">
            <img src={OctoOcto} alt="contact"></img>
          </a>
        </div>
      </main>
    </div>
  );
}

export default App;
